import React, { PureComponent } from 'react';

import { services } from '@comall-backend-builder/core';
import { localStorage } from '@comall-backend-builder/core/lib/services';
import { Button } from '@comall-backend-builder/components-basis';
import { message as AntMessage, Popconfirm as AntPopconfirm } from 'antd';
import { errorHandle } from '../../services';

const api = services.api;

/**
 * 直播间列表页 操作按钮
 */
export class LiveRoomActionButton extends PureComponent<any, any> {
    info = (activeTab: string) => {
        const { row } = this.props;
        localStorage.set('LIVE_ROOM_INFO', row);
        services.navigation.goto(`/live-room/info/${row.roomid}/${activeTab}`);
    };

    delete = () => {
        const {
            entity,
            row: { id },
        } = this.props;
        api.delete({}, { apiPath: `/live/room/del/${id}` })
            .then(() => {
                AntMessage.success('删除成功');

                // 列表数据刷新
                entity.search({
                    ...entity.params,
                    ...entity.filters,
                });
            })
            .catch(errorHandle);
    };

    renderImportBtn() {
        const btnProps = {
            text: '导入商品',
            style: {
                marginRight: 10,
            },
            onClick: this.info.bind(this, '1'),
        };
        return <Button {...btnProps} type="link" />;
    }

    renderDetailBtn() {
        const btnProps = {
            text: '查看',
            style: {
                marginRight: 10,
            },
            onClick: this.info.bind(this, '0'),
        };
        return <Button {...btnProps} type="link" />;
    }

    renderDeleteBtn() {
        const confirmProps = {
            title: '确定要删除吗？',
            okText: '确定',
            cancelText: '取消',
            onConfirm: this.delete,
        };
        const btnProps = {
            text: '删除',
        };
        return (
            <AntPopconfirm {...confirmProps}>
                <Button {...btnProps} type="link" />
            </AntPopconfirm>
        );
    }

    render() {
        const {
            row: { liveStatus, showStatus },
        } = this.props;

        let btnElement = (
            <div>
                {this.renderDetailBtn()}
                {(liveStatus === 101 || liveStatus === 102) && this.renderImportBtn()}
                {showStatus !== 'DISPLAY' && this.renderDeleteBtn()}
            </div>
        );

        return btnElement;
    }
}
